<template>
<form
  :method="methodType"
  accept-charset="UTF-8"
  autocomplete="off"
  id="provider-form"
  :reset="true"
  v-on:submit.prevent="submit"
>
  <div class="form-group">
    <label for="provider_title">
      Provider Title
    </label>

    <input
      type="text"
      name="provider[title]"
      id="provider_title"
      class="form-control"
      v-model="provider.title"
    />
  </div>

  <div class="form-group">
    <label for="provider_short_title">
      Provider Short Title
    </label>

    <input
      type="text"
      name="provider[short_title]"
      id="provider_short_title"
      class="form-control"
      v-model="provider.short_title"
      :placeholder="defaultShortTitle"
    />
  </div>

  <div class="form-group">
    <label for="provider_url_title">
      Provider Slug
    </label>

    <input
      type="text"
      name="provider[url_title]"
      id="provider_url_title"
      class="form-control"
      v-model="provider.url_title"
    />
  </div>

  <div class="form-group">
    <label for="provider_description">
      Provider Description
    </label>

    <textarea
      name="provider[description]"
      id="provider_description"
      class="form-control"
      v-model="provider.description"
    />
  </div>

  <div class="form-group">
    <newsletter-type-picker
      newsletterTypeLbl="Attach Provider Puzzles to Newsletter Types"
      :selectedNewsletterTypeIds="selectedNewsletterTypeIds"
      multiple
      v-model="provider.provider_newsletter_type_ids"
      v-on:newsletter-types-changed="newsletterTypesChanged"
    />
  </div>

  <!--
  <div class="form-group">
    <label for="provider_url">
      Provider URL
    </label>

    <input
      type="text"
      name="provider[url]"
      id="provider_url"
      class="form-control"
      v-model="provider.url"
    />
  </div>
  -->

  <div class="form-group">
    <label for="provider_frequency">
      Provider Publishing Frequency
    </label>

    <select
      name="provider[frequency]"
      id="provider_frequency"
      class="form-control"
      v-on:change="setFrequency"
    >
      <option
        v-for="option in frequencyOptions"
        :value="option.val"
        :selected="isSelectedFrequency(option.val)"
      >
        {{ option.lbl }}
      </option>
    </select>
  </div>

  <div
    class="form-group"
    v-if="provider.id"
  >
    <author-picker
      inputName="provider[authors]"
      :authorsLbl="authorLbl"
      :selectedAuthorIds="selectedAuthorIds"
      v-on:authors-changed="authorsChanged"
    />
    <div
      v-if="provider"
    >
      <div
        v-if="provider.authors && provider.authors.length"
      >
        <p>
          Current {{ authorLbl }}
        </p>
        <div
          v-for="author in provider.authors"
        >
          <router-link
            :to="{
              name: 'author',
              params: {
                authorId: author.id
              }
            }"
          >
            {{ author.name }}
          </router-link>
        </div>
      </div>
      <p
        v-else
        class="alert alert-danger text-center"
      >
        No {{ authorLbl }}
      </p>
    </div>
  </div>

  <div class="form-group">
    <label for="provider_featured">
      <input
        type="hidden"
        name="provider[featured]"
        value="false"
      />
      <input
        type="checkbox"
        name="provider[featured]"
        id="provider_featured"
        v-model="provider.featured"
      />

      Featured Provider?
    </label>
  </div>

  <div class="form-group">
    <label for="provider_purchasable">
      <input type="hidden" name="provider[purchasable]" value="false" />
      <input
        type="checkbox"
        name="provider[purchasable]"
        id="provider_purchasable"
        v-model="provider.purchasable"
      />

      Puzzles Can Be Purchased?
    </label>
  </div>

  <div class="form-group">
    <label for="provider_digestible">
      <input type="hidden" name="provider[digestible]" value="false" />
      <input
        type="checkbox"
        name="provider[digestible]"
        id="provider_digestible"
        v-model="provider.digestible"
      />

      Included in Email Digests?
    </label>
  </div>

  <div class="form-group">
    <label for="provider_inactive">
      <input type="hidden" name="provider[inactive]" value="false" />
      <input
        type="checkbox"
        name="provider[inactive]"
        id="provider_inactive"
        v-model="provider.inactive"
      />

      Inactive?
    </label>
  </div>

  <div class="form-group">
    <label for="provider_public">
      <input type="hidden" name="provider[public]" value="false" />
      <input
        type="checkbox"
        name="provider[public]"
        id="provider_public"
        v-model="provider.public"
      />

      Public?
    </label>
  </div>

  <div
    class="form-group"
  >

  <button
    class="form-control btn-block btn-primary"
    type="submit"
  >
    {{ actionLbl }} Provider
  </button>

  </div>

  <div
    class="form-group"
    id="provider-destructive-options"
    v-if="providerId"
  >
    <button
      class="form-control btn-block btn-danger"
      v-on:click.prevent="destroy"
      v-if="provider.id"
    >
       Delete Provider
    </button>
  </div>
</form>
</template>

<script>
import AuthorPicker from '@/components/AuthorPicker'
import NewsletterTypePicker from '@/components/NewsletterTypePicker'

import FlashStore from '@/stores/FlashStore'

import { mapState } from 'vuex'

export default {
  data () {
    return {
      selectedFrequency: undefined
    }
  },

  components: {
    'author-picker': AuthorPicker,
    'newsletter-type-picker': NewsletterTypePicker
  },

  computed: mapState({
    base: state => state.base,
    provider: state => state.ProviderModule.provider,

    action () {
      return this.providerId ? 'update' : 'create'
    },

    actionLbl () {
      return this.providerId ? 'Edit' : 'Create'
    },

    authorLbl () {
      return 'Featured Authors'
    },

    frequencyOptions () {
      return [
        {
          lbl: 'Sunday',
          val: 0
        },
        {
          lbl: 'Monday',
          val: 1
        },
        {
          lbl: 'Tuesday',
          val: 2
        },
        {
          lbl: 'Wednesday',
          val: 3
        },
        {
          lbl: 'Thursday',
          val: 4
        },
        {
          lbl: 'Friday',
          val: 5
        },
        {
          lbl: 'Saturday',
          val: 6
        },
        {
          lbl: 'Variable',
          val: '*'
        }
      ]
    },

    methodType () {
      return this.providerId ? 'PUT' : 'POST'
    },

    defaultShortTitle () {
      return this.provider.short_title || this.provider.title
    },

    selectedAuthorIds () {
      if (this.provider.authors) {
        return this.provider.authors.map((author) => {
          return author.id
        })
      }
    },

    selectedNewsletterTypeIds () {
      if (this.provider.provider_newsletter_types) {
        return this.provider.provider_newsletter_types.map((newsletterType) => {
          return newsletterType.id
        })
      }
    }
  }),

  props: [
    'providerId'
  ],

  created () {
    if (this.providerId) {
      this.get()
    } else {
      this.initialize()
    }
  },

  methods: {
    initialize () {
      this.$store.dispatch(
        'ProviderModule/newProvider'
      ).catch(this.$root.processErrors)
    },

    get () {
      this.$store.dispatch(
        'ProviderModule/getProvider', this.providerId
      ).catch(this.$root.processErrors)
    },

    destroy () {
      if (confirm(
        'Are you sure you want to delete this Provider?'
      )) {
        if (confirm(
          'Are you absolutely sure? You cannot undo Provider deletion.'
        )) {
          this.$store.dispatch(
            'ProviderModule/destroyProvider', this.providerId
          ).then(() => {
            this.$router.push({
              name: 'providers'
            })

            FlashStore.result('Provider deleted.')
          }).catch(this.$root.processErrors)
        }
      }
    },

    resetApiToken () {
      if (confirm(
        'Are you sure you want to regenerate this Provider API Token? ' +
        'This provider will no longer be able access the service ' +
        'until they update it with the new token.'
      )) {
        this.$http.post(
          this.apiUrl(
            '/providers/' + this.providerId + '/regenerate_api_token', true
          )
        ).then((resp) => {
          this.processSuccess(resp)

          this.$router.push({
            name: 'provider',
            params: {
              'providerId': this.providerId
            }
          })

          FlashStore.result('API token regenerated.')
        }, this.processErrors)
      }
    },

    authorsChanged (authorIds) {
      this.$store.dispatch(
        `ProviderModule/setAuthorIds`, authorIds
      ).catch(this.$root.processErrors)
    },

    newsletterTypesChanged (newsletterTypeIds) {
      this.$store.dispatch(
        `ProviderModule/setNewsletterTypeIds`, newsletterTypeIds
      ).catch(this.$root.processErrors)
    },

    isSelectedFrequency (freq) {
      return parseInt(this.provider.frequency) === parseInt(freq)
    },

    setFrequency (ev) {
      this.$store.dispatch(
        `ProviderModule/setFrequency`, ev.target.value
      ).catch(this.$root.processErrors)
    },

    setNewsletterTypes (ev) {
      console.log('NEWSLETTER TPYES')
      console.table(ev.target.value)
    },

    submit (ev) {
      this.$store.dispatch(
        `ProviderModule/${this.action}Provider`
      ).then(() => {
        if (!this.providerId) {
          this.$router.push({
            name: 'edit_provider',
            params: {
              providerId: this.provider.id
            }
          })
        } else {
          this.$router.push({
            name: 'provider',
            params: {
              providerId: this.provider.id
            }
          })
        }

        FlashStore.result(`This provider has been ${this.action}d.`)
      }).catch(this.$root.processErrors)
    },

    processErrors (resp) {
      this.$parent.processErrors(resp)
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/ProviderForm.vue